import { Component, Inject, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { Store } from '@ngrx/store';

import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { selectAuthLoggedIn, selectLoggedInUserDataId } from 'src/app/common/store/state/app.state';
import { Observable } from 'rxjs';
import { CdkOverlayOrigin } from '@angular/cdk/overlay';
import { AsyncPipe } from '@angular/common';
import { MatCalendar } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AppFunctions } from 'src/app/public/common/constants/app-functions';
import { Review } from '../../models/review.model';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';


@Component({
    selector: 'app-review-dialog',
    templateUrl: './review-dialog.component.html',
    styleUrls: ['./review-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, MatFormFieldModule, MatInputModule, MatDialogModule, MatIconModule, MatProgressSpinnerModule, MatIconModule, MatDividerModule, MatCheckboxModule, AsyncPipe]
})
export class ReviewDialogComponent implements OnInit{

    currentlyLogginIn$: Observable<boolean>;
    currentlyLogginIn: boolean = false;

    loggedInUserId$ : Observable<string>;
    loggedInUserId: string = ""

    isReply: boolean = false;
  
    showDetails: boolean = false;
  
    userRatingIndicators = [0,0,0,0,0];
  
  constructor(
    public dialogRef: MatDialogRef<ReviewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Review,
    private store: Store) {

        this.currentlyLogginIn$ = store.select(selectAuthLoggedIn);
        this.loggedInUserId$ = store.select(selectLoggedInUserDataId);

    }

    ngOnInit(): void {

        this.currentlyLogginIn$.subscribe(
            (lg: boolean) => this.currentlyLogginIn = lg
        );
  
    } 
  
    onNoClick(): void {
      this.dialogRef.close();
    }


    dateFormat(dt: string): string{

        return AppFunctions.stringToDatetime(dt);
        }
    
/*
    recordReview(review: Review){
        
        if(review.rate < 1  || review.rate > 5){
            alert("Veuillez choisir la note");
            return;
        }
        
        this.store.dispatch(DealerActions.addNewReviewSubmit({review: review, ratedId: review.ratedId}));
    
        this.dialogRef.close();
    }

    replyReview( reply: string, carId: string, conversationId: string){
        //console.log("reply = "+reply+" car = "+carId+" conv = "+conversationId)

        this.store.dispatch(DealerActions.replyReviewSubmit({review: review, ratedId: review.ratedId}));
    

        this.dialogRef.close();
        
    }

    */
}
